import { memo } from 'react'

import { createStyles, makeStyles } from '@mui/styles'
import { Theme, Skeleton } from '@mui/material'

const useStyles = makeStyles<Theme>((muiTheme: Theme) =>
  createStyles({
    loadingSkeletonWrapper: {
      padding: '22px 26px 0px 26px',
      maxWidth: 1200,
      margin: 'auto',
    },
    loadingSkeletonContainer: {
      padding: '0 15px',
      marginBottom: '15px',
      display: 'flex',
      flexDirection: 'column',
      border: `1px solid ${muiTheme.palette.grey[200]}`,
      borderRadius: 5,
    },
    loadingSkeletonContainerDetails: {
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: '1fr 200px',
      alignItems: 'center',
      gap: 20,
      [muiTheme.breakpoints.down('md')]: {
        gridAutoFlow: 'row',
        gridTemplateColumns: '1fr',
      },
    },
    loadingSkeletonContainerContent: {
      display: 'grid',
      gridTemplateColumns: '1fr repeat(2, 150px) 0.5fr',
      alignItems: 'center',
      minHeight: 120,
      gap: 20,
      [muiTheme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr 1fr',
        rowGap: 0,
      },
    },
  }),
)

const LoadingSkeleton = () => {
  const {
    loadingSkeletonWrapper,
    loadingSkeletonContainer,
    loadingSkeletonContainerDetails,
    loadingSkeletonContainerContent,
  } = useStyles()

  return (
    <div className={loadingSkeletonWrapper}>
      {Array.from({ length: 3 }, (_, index) => (
        <div
          className={loadingSkeletonContainer}
          key={`loading-skeleton-${index}`}
        >
          <div className={loadingSkeletonContainerDetails}>
            <div className={loadingSkeletonContainerContent}>
              <Skeleton
                sx={{ bgcolor: 'grey.100', height: '100px' }}
                animation='wave'
              />
              <Skeleton
                sx={{ bgcolor: 'grey.100', height: '100px' }}
                animation='wave'
              />
              <Skeleton
                sx={{ bgcolor: 'grey.100', height: '100px' }}
                animation='wave'
              />
              <Skeleton
                sx={{ bgcolor: 'grey.100', height: '100px' }}
                animation='wave'
              />
            </div>
            <Skeleton
              sx={{
                bgcolor: 'grey.100',
                height: '100px',
              }}
              animation='wave'
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default memo(LoadingSkeleton)
